import { Button } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import ImageCrop from '@/features/dashboard/account/ImageCrop'
import { useFullScreenDialog } from '@/hooks/useFullScreenDialog'

const ModalProfilePicture = ({ openState = false, closeModal, mutation }) => {
    const fullScreen = useFullScreenDialog()
    const [imageSelected, setImageSelected] = useState(false)
    const [image, setCompleteImage] = useState(null)

    const handleClose = () => {
        setImageSelected(false)
        closeModal()
    }

    const generateImageAndMutate = async () => {
        try {
            await mutation.mutateAsync({ avatar_image: image })
            handleClose()
        } catch (_error) {
            // Error state is handled by the mutation consumer.
        }
    }

    return (
        <>
            <Dialog
                fullScreen={fullScreen}
                open={openState}
                onClose={handleClose}
                fullWidth
                disableRestoreFocus
            >
                <DialogContent>
                    <ImageCrop
                        setImageSelected={setImageSelected}
                        setCompleteImage={setCompleteImage}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        type="button"
                        onClick={(event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            handleClose()
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={!imageSelected}
                        variant="contained"
                        type="button"
                        onClick={async (event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            await generateImageAndMutate()
                        }}
                    >
                        {mutation.isPending ? 'Saving...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

ModalProfilePicture.propTypes = {
    openState: PropTypes.bool,
    closeModal: PropTypes.func,
    mutation: PropTypes.object
}

export default ModalProfilePicture
